import { defineStore } from 'pinia'
import type { SplitTimeData } from '@powerplay/core-minigames'

export interface SplitTimeState {
  splitTimes: string[],
  actualTime: string,
  splitTimeData: SplitTimeData[],
  rerenderKey: boolean,
  showPlayerTime: boolean
}

const initialState = (): SplitTimeState => ({
  splitTimes: [],
  actualTime: '',
  splitTimeData: [],
  rerenderKey: false,
  showPlayerTime: false
})

export const splitTimeState = defineStore('splitTimeState', {
  state: initialState,
})
